import { Injectable, inject } from '@angular/core';

import { map, mergeMap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { environment } from '@rocksoft/environment';
import { CategoryWifiProfileConfigurationService } from '@rocksoft/settings-sdk';
import { safeMap } from '../effects.helpers';
import {
  CategoryWifiProfilePresetConfigurationApiActions,
  CategoryWifiProfilePresetConfigurationViewActions,
} from './category-wifi-profile-preset-configuration.actions';
import { CategoryResolvedConfigurationResolverActions } from '../category-resolved-configuration/category-resolved-configuration.actions';

@Injectable()
export class CategoryWifiProfileEffects {
  private readonly actions = inject(Actions);
  private readonly categoryWifiProfileService = inject(CategoryWifiProfileConfigurationService);

  protected features = environment.features;

  /**
   * The category wifi profile configuration has been updated.
   * Effect: we submit the update to the api and dispatch an error if applicable.
   */
  categoryWifiProfileLinkUpdatedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(CategoryWifiProfilePresetConfigurationViewActions.wifiProfilePresetConfigurationsUpdated),
      mergeMap((action) => {
        const categoryType = action.category.categoryType;

        const command = {
          wifiProfilePresets: action.updatedWifiProfilesLinkedToCategory.map((x) => ({
            wifiProfilePresetId: x.wifiProfileId,
            models: x.models,
          })),
        };

        return safeMap(
          this.categoryWifiProfileService.putWifiProfileToCategory({
            categoryType,
            categoryId: action.category.categoryId,
            setWifiProfilesForCategoryCommand: command,
          }),
          () =>
            CategoryResolvedConfigurationResolverActions.categoryResolvedConfigurationRequested({
              categoryId: action.category.categoryId,
            }),
          (error) =>
            CategoryWifiProfilePresetConfigurationApiActions.categoryWifiProfilePresetConfigurationsUpdatedError({
              category: action.category,
              error,
            })
        );
      })
    );
  });

  /**
   * The wifi profiles couldn't be updated.
   * Effect: we request a reload of the state from the api.
   */
  categoryWifiProfilesUpdatedErrorEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(CategoryWifiProfilePresetConfigurationApiActions.categoryWifiProfilePresetConfigurationsUpdatedError),
      map((action) =>
        CategoryResolvedConfigurationResolverActions.categoryResolvedConfigurationRequested({
          categoryId: action.category.categoryId,
        })
      )
    );
  });
}
